import {useTheme} from '../context/ThemeContext.js'
import '../App.css'

const data = [
    { id: 1, name: 'ASOS Ridley High Waist', price: 79.49, quantity: 82, amount: 6518.18 },
    { id: 2, name: 'Marco Lightweight Shirt', price: 128.50, quantity: 37, amount: 4754.50 },
    { id: 3, name: 'Half Sleeve Shirt', price: 39.99, quantity: 64, amount: 2559.36 },
    { id: 4, name: 'Lightweight Jacket', price: 20.00, quantity: 184, amount: 3680.00 },
    { id: 5, name: 'Marco Shoes', price: 79.49, quantity: 64, amount: 1965.81 },
];

export default function TopProducts() {
    const {theme} = useTheme();
    return (
        <div className={` ${theme === '#1c1c1c' ? 'bg-[#282828]' : 'bg-[#f7f9fb]'} App p-6 w-[662px] h-[336px] rounded-xl hover:scale-105 transition-transform`}>
            <p className='text-sm my-bold'>Top Selling Products</p>
            <div className='w-full mt-4 text-left'>
                <div className='flex mb-2 text-sm App font-normal text-[#9fa1a2] border-b-2 border-b-[#cbcdce]'>
                    <div className='pb-2 w-[240px]'>Name</div>
                    <div className='pb-2 flex-1'>Price</div>
                    <div className='pb-2 flex-1'>Sold</div>
                    <div className='pb-2 flex-1'>Amount</div>
                </div>
                {data.map((item) => (
                    <div key={item.id} className='flex text-sm pb-2'>
                        <div className='py-2 w-[240px]'>{item.name}</div>
                        <div className='py-2 flex-1'>${item.price.toFixed(2)}</div>
                        <div className='py-2 flex-1'>{item.quantity}</div>
                        <div className='py-2 flex-1'>${item.amount.toFixed(2)}</div>
                    </div>
                ))}
            </div>
        </div>
    )
}